{
  "$comentario": "Generado por tools/extraer-catalogo. No editar a mano: npm run catalogo",
  "version": 1,
  "zonas": [
    {
      "id": "parachoques_delantero",
      "nombre": "Parachoques delantero",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 46,
        "y": 12,
        "ancho": 108,
        "alto": 24,
        "radio": 12
      }
    },
    {
      "id": "capo",
      "nombre": "Capó",
      "extra": false,
      "geometria": {
        "tipo": "path",
        "d": "M48 40 H152 L146 112 H54 Z",
        "centro": [
          100,
          76
        ]
      }
    },
    {
      "id": "parabrisas",
      "nombre": "Parabrisas",
      "extra": false,
      "geometria": {
        "tipo": "path",
        "d": "M56 116 H144 L134 150 H66 Z",
        "centro": [
          100,
          133
        ]
      }
    },
    {
      "id": "techo",
      "nombre": "Techo",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 66,
        "y": 154,
        "ancho": 68,
        "alto": 98,
        "radio": 6
      }
    },
    {
      "id": "luneta",
      "nombre": "Luneta",
      "extra": false,
      "geometria": {
        "tipo": "path",
        "d": "M66 256 H134 L142 284 H58 Z",
        "centro": [
          100,
          270
        ]
      }
    },
    {
      "id": "tapa_maletero",
      "nombre": "Tapa maletero",
      "extra": false,
      "geometria": {
        "tipo": "path",
        "d": "M54 288 H146 L152 358 H48 Z",
        "centro": [
          100,
          323
        ]
      }
    },
    {
      "id": "parachoques_trasero",
      "nombre": "Parachoques trasero",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 46,
        "y": 362,
        "ancho": 108,
        "alto": 26,
        "radio": 12
      }
    },
    {
      "id": "tapabarro_delantero_izquierdo",
      "nombre": "Tapabarro delantero izquierdo",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 18,
        "y": 44,
        "ancho": 26,
        "alto": 72,
        "radio": 8
      }
    },
    {
      "id": "puerta_delantera_izquierda",
      "nombre": "Puerta delantera izquierda",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 18,
        "y": 120,
        "ancho": 26,
        "alto": 84,
        "radio": 6
      }
    },
    {
      "id": "puerta_trasera_izquierda",
      "nombre": "Puerta trasera izquierda",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 18,
        "y": 208,
        "ancho": 26,
        "alto": 76,
        "radio": 6
      }
    },
    {
      "id": "tapabarro_trasero_izquierdo",
      "nombre": "Tapabarro trasero izquierdo",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 18,
        "y": 288,
        "ancho": 26,
        "alto": 72,
        "radio": 8
      }
    },
    {
      "id": "tapabarro_delantero_derecho",
      "nombre": "Tapabarro delantero derecho",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 156,
        "y": 44,
        "ancho": 26,
        "alto": 72,
        "radio": 8
      }
    },
    {
      "id": "puerta_delantera_derecha",
      "nombre": "Puerta delantera derecha",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 156,
        "y": 120,
        "ancho": 26,
        "alto": 84,
        "radio": 6
      }
    },
    {
      "id": "puerta_trasera_derecha",
      "nombre": "Puerta trasera derecha",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 156,
        "y": 208,
        "ancho": 26,
        "alto": 76,
        "radio": 6
      }
    },
    {
      "id": "tapabarro_trasero_derecho",
      "nombre": "Tapabarro trasero derecho",
      "extra": false,
      "geometria": {
        "tipo": "rect",
        "x": 156,
        "y": 288,
        "ancho": 26,
        "alto": 72,
        "radio": 8
      }
    },
    {
      "id": "vidrios_laterales",
      "nombre": "Vidrios laterales",
      "extra": true,
      "geometria": null
    },
    {
      "id": "llantas_aros",
      "nombre": "Llantas / aros",
      "extra": true,
      "geometria": null
    },
    {
      "id": "neumaticos",
      "nombre": "Neumáticos",
      "extra": true,
      "geometria": null
    }
  ],
  "viewBox": [
    0,
    0,
    200,
    400
  ],
  "estadosZona": [
    {
      "id": "sin",
      "simbolo": "✓",
      "nombre": "Sin daño",
      "severidad": 0,
      "requiereFoto": false
    },
    {
      "id": "ray",
      "simbolo": "≈",
      "nombre": "Rayado",
      "severidad": 1,
      "requiereFoto": true
    },
    {
      "id": "gol",
      "simbolo": "●",
      "nombre": "Golpeado",
      "severidad": 2,
      "requiereFoto": true
    },
    {
      "id": "que",
      "simbolo": "✕",
      "nombre": "Quebrado",
      "severidad": 3,
      "requiereFoto": true
    },
    {
      "id": "na",
      "simbolo": "∅",
      "nombre": "No aplica",
      "severidad": null,
      "requiereFoto": false
    }
  ],
  "accesorios": [
    {
      "id": "documentos",
      "nombre": "Documentos"
    },
    {
      "id": "radio",
      "nombre": "Radio"
    },
    {
      "id": "set_de_seguridad",
      "nombre": "Set de seguridad"
    },
    {
      "id": "cono_rueda",
      "nombre": "Cono rueda"
    },
    {
      "id": "espejos_exteriores",
      "nombre": "Espejos exteriores"
    },
    {
      "id": "tag",
      "nombre": "Tag"
    },
    {
      "id": "panel_de_radio",
      "nombre": "Panel de radio"
    },
    {
      "id": "limpia_parabrisas",
      "nombre": "Limpia parabrisas"
    },
    {
      "id": "logos",
      "nombre": "Logos"
    },
    {
      "id": "destono_de_color",
      "nombre": "Destono de color"
    },
    {
      "id": "alarma",
      "nombre": "Alarma"
    },
    {
      "id": "kit_manos_libres",
      "nombre": "Kit manos libres"
    },
    {
      "id": "llave_de_rueda",
      "nombre": "Llave de rueda"
    },
    {
      "id": "antena",
      "nombre": "Antena"
    },
    {
      "id": "pulverizado",
      "nombre": "Pulverizado"
    },
    {
      "id": "llaves",
      "nombre": "Llaves"
    },
    {
      "id": "encendedor",
      "nombre": "Encendedor"
    },
    {
      "id": "neumatico_de_repuesto",
      "nombre": "Neumático de repuesto"
    },
    {
      "id": "plumillas",
      "nombre": "Plumillas"
    },
    {
      "id": "sensores_de_retroceso",
      "nombre": "Sensores de retroceso"
    },
    {
      "id": "neblineros",
      "nombre": "Neblineros"
    },
    {
      "id": "cenicero",
      "nombre": "Cenicero"
    },
    {
      "id": "parasol",
      "nombre": "Parasol"
    },
    {
      "id": "cierre_centralizado",
      "nombre": "Cierre centralizado"
    },
    {
      "id": "aire_acondicionado",
      "nombre": "Aire acondicionado"
    },
    {
      "id": "parabrisas",
      "nombre": "Parabrisas"
    },
    {
      "id": "piso_de_goma",
      "nombre": "Piso de goma"
    },
    {
      "id": "tapa_bencina",
      "nombre": "Tapa bencina"
    },
    {
      "id": "cubre_pick_up",
      "nombre": "Cubre pick up"
    },
    {
      "id": "luz_interior_maleta",
      "nombre": "Luz interior maleta"
    },
    {
      "id": "check_engine_encendido",
      "nombre": "Check engine encendido"
    },
    {
      "id": "alzavidrio",
      "nombre": "Alzavidrio"
    },
    {
      "id": "tapiz_manchado",
      "nombre": "Tapiz manchado"
    },
    {
      "id": "gata",
      "nombre": "Gata"
    },
    {
      "id": "camara_de_retroceso",
      "nombre": "Cámara de retroceso"
    },
    {
      "id": "patente_1_2",
      "nombre": "Patente 1-2"
    },
    {
      "id": "tarjeta_sd_navegacion",
      "nombre": "Tarjeta SD / Navegación"
    },
    {
      "id": "tapa_rueda",
      "nombre": "Tapa rueda"
    },
    {
      "id": "espejo_interior",
      "nombre": "Espejo interior"
    },
    {
      "id": "luz_habitaculo",
      "nombre": "Luz habitáculo"
    },
    {
      "id": "luces_altas",
      "nombre": "Luces altas"
    },
    {
      "id": "luces_intermitentes",
      "nombre": "Luces intermitentes"
    },
    {
      "id": "luz_de_freno",
      "nombre": "Luz de freno"
    },
    {
      "id": "luces_bajas",
      "nombre": "Luces bajas"
    },
    {
      "id": "luz_de_reversa",
      "nombre": "Luz de reversa"
    }
  ],
  "estadosAccesorio": [
    {
      "id": "presente",
      "nombre": "Presente"
    },
    {
      "id": "ausente",
      "nombre": "Ausente"
    },
    {
      "id": "sin_revisar",
      "nombre": "Sin revisar"
    }
  ],
  "nivelesCombustible": [
    {
      "indice": 0,
      "etiqueta": "0"
    },
    {
      "indice": 1,
      "etiqueta": "1/4"
    },
    {
      "indice": 2,
      "etiqueta": "3/8"
    },
    {
      "indice": 3,
      "etiqueta": "1/2"
    },
    {
      "indice": 4,
      "etiqueta": "5/8"
    },
    {
      "indice": 5,
      "etiqueta": "3/4"
    },
    {
      "indice": 6,
      "etiqueta": "7/8"
    },
    {
      "indice": 7,
      "etiqueta": "Full"
    }
  ],
  "fases": [
    {
      "id": "recepcion",
      "nombre": "Recepción",
      "cupo": 15,
      "duracionDias": 1,
      "umbralAtrasoDias": 2
    },
    {
      "id": "presupuesto",
      "nombre": "Presupuesto",
      "cupo": 10,
      "duracionDias": 2,
      "umbralAtrasoDias": 3
    },
    {
      "id": "aseguradora",
      "nombre": "Aseguradora",
      "cupo": 10,
      "duracionDias": 3,
      "umbralAtrasoDias": 4
    },
    {
      "id": "esperando_repuestos",
      "nombre": "Esperando repuestos",
      "cupo": 8,
      "duracionDias": 5,
      "umbralAtrasoDias": 7
    },
    {
      "id": "ingreso_seguridad",
      "nombre": "Ingreso / Seguridad",
      "cupo": 5,
      "duracionDias": 1,
      "umbralAtrasoDias": 2
    },
    {
      "id": "pintura",
      "nombre": "Pintura",
      "cupo": 3,
      "duracionDias": 2,
      "umbralAtrasoDias": 3
    },
    {
      "id": "pulido",
      "nombre": "Pulido",
      "cupo": 3,
      "duracionDias": 1,
      "umbralAtrasoDias": 2
    },
    {
      "id": "limpieza",
      "nombre": "Limpieza",
      "cupo": 3,
      "duracionDias": 1,
      "umbralAtrasoDias": 2
    },
    {
      "id": "entrega",
      "nombre": "Entrega",
      "cupo": 10,
      "duracionDias": 0,
      "umbralAtrasoDias": 3
    }
  ],
  "motivosIngreso": [
    {
      "id": "siniestro",
      "nombre": "Siniestro",
      "pideSiniestro": true
    },
    {
      "id": "particular",
      "nombre": "Particular",
      "pideSiniestro": false
    },
    {
      "id": "garantia",
      "nombre": "Garantía",
      "pideSiniestro": false
    }
  ],
  "tiposInspeccion": [
    "siniestro",
    "recepcion",
    "reingreso",
    "entrega"
  ],
  "avisosLegales": [
    "La empresa no se responsabiliza por objetos de valor que queden dentro del vehículo.",
    "Autorizo el traslado del vehículo entre sucursales. El pago de deducible es en efectivo o vía transferencia electrónica.",
    "Una vez avisado que el vehículo está listo, debe retirarlo a las 48 horas como máximo o se cobrarán 0,25 UF diarios."
  ],
  "fotos": {
    "$comentario": "Compresión del máster de evidencia: se comprime una vez y nunca se recorta; ladoMax null = resolución de la cámara. Calidad = la más baja con SSIMULACRA2 p10 >= 80 en ese lado (tools/calibracion-fotos, docs/fotos-evidencia.md). kbMedio = peso medio medido del máster (maxima: Pixel 7 Pro real; equilibrado/ahorro: harness), para estimar el costo.",
    "perfilPorDefecto": "maxima",
    "perfiles": [
      {
        "id": "maxima",
        "nombre": "Máxima",
        "ladoMax": null,
        "calidad": 80,
        "kbMedio": 1450
      },
      {
        "id": "equilibrado",
        "nombre": "Equilibrado",
        "ladoMax": 3072,
        "calidad": 80,
        "kbMedio": 943
      },
      {
        "id": "ahorro",
        "nombre": "Ahorro",
        "ladoMax": 2048,
        "calidad": 85,
        "kbMedio": 568
      }
    ],
    "calidad": {
      "min": 60,
      "max": 95
    },
    "ladoMax": {
      "min": 1024,
      "max": 8192
    }
  }
}
